export default class EventsWebservice {
	constructor(complement=null) {
		this.url = '/events-webservice' + (complement || '');
	}
}



// WEBPACK FOOTER //
// ./src/services/EventsWebservice.js